import React from "react";
import "../printStyles.css";

function FireSafetyCheck() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #FireSafetyCheck, #FireSafetyCheck * {
              visibility: visible;
            }
            #FireSafetyCheck {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="FireSafetyCheck" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Fire Alarm & Safety Equipment Check</h3>

        <form>
          {/* Location */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="location">
              Location:
            </label>
            <input
              type="text"
              id="location"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter location"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Checked By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="checkedBy">
              Checked By (Name):
            </label>
            <input
              type="text"
              id="checkedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="date">
              Date:
            </label>
            <input
              type="date"
              id="date"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Fire Safety Items */}
          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-4 text-gray-800">Items to Check</h4>

            {/* Fire Alarm System */}
            <div className="mb-4">
              <h5 className="text-lg font-medium text-gray-700 mb-2">Fire Alarm System:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">OK</span>
                </label>
                <input
                  type="time"
                  id="fireAlarmTestTime"
                  className="p-2 border border-gray-300 rounded-lg w-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Test Time"
                />
              </div>
            </div>

            {/* Smoke Detectors */}
            <div className="mb-4">
              <h5 className="text-lg font-medium text-gray-700 mb-2">Smoke Detectors:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">OK</span>
                </label>
                <input
                  type="time"
                  id="smokeDetectorTestTime"
                  className="p-2 border border-gray-300 rounded-lg w-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Test Time"
                />
              </div>
            </div>

            {/* Fire Extinguishers */}
            <div className="mb-4">
              <h5 className="text-lg font-medium text-gray-700 mb-2">Fire Extinguishers:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">OK</span>
                </label>
                <input
                  type="time"
                  id="fireExtinguisherTestTime"
                  className="p-2 border border-gray-300 rounded-lg w-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Test Time"
                />
              </div>
            </div>

            {/* Emergency Exits */}
            <div className="mb-4">
              <h5 className="text-lg font-medium text-gray-700 mb-2">Emergency Exits:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">OK</span>
                </label>
                <input
                  type="time"
                  id="emergencyExitsTestTime"
                  className="p-2 border border-gray-300 rounded-lg w-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Test Time"
                />
              </div>
            </div>

            {/* First Aid Kit */}
            <div className="mb-4">
              <h5 className="text-lg font-medium text-gray-700 mb-2">First Aid Kit:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">OK</span>
                </label>
                <input
                  type="time"
                  id="firstAidKitTestTime"
                  className="p-2 border border-gray-300 rounded-lg w-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Test Time"
                />
              </div>
            </div>

            {/* Overall Condition */}
            <div className="mb-4">
              <h5 className="text-lg font-medium text-gray-700 mb-2">Overall Condition:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">All OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500 h-5 w-5 rounded" />
                  <span className="text-sm">Action Required</span>
                </label>
              </div>
            </div>
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Add any additional notes here..."
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()} // Will trigger the print dialog
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default FireSafetyCheck;